import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './Radio.css'

@CSSModules(styles, { allowMultiple: true })
export default class Radio extends Component {
  static propTypes = {
    errorMessage: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string
  }

  static defaultProps = {
    checked: false
  }  

  constructor (props) {
    super(props)
    this.state = {
      checked: null
    }
  }
    
  _onChange (event) {
    this.setState({ checked: event.target.value })
    this.props.onChange(event.target.value)
  }

  render () {
    const { errorMessage, name, options, title } = this.props
    return (
      <div>
        <h2>{title}</h2>
        <div styleName="radio-container">
          <div styleName={errorMessage === '' ? 'no-error' : 'has-error' + ' error'}>
            <div />
            <span>{errorMessage}</span>
          </div>        
          {options.map((option, i) => (
            <div key={name + i} styleName="radio-button">
              <input
                checked={this.state.checked === option}
                id={name + i}
                name={name}
                onChange={this._onChange.bind(this)}
                type="radio"
                value={option}
              />
              <label htmlFor={name + i}>
                <div styleName="indicator"/>
                <span styleName="radio-text">{option}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Radio/Radio.js